function tabClick(e) {
  9 === e.keyCode &&
    (document.body.classList.add('js-using-tab'), window.removeEventListener('keydown', tabClick));
}
window.addEventListener('keydown', tabClick),
  (window.theme ??= {}),
  (window.theme.wrapRteTables = (e = document) => {
    e.querySelectorAll('.rte table').forEach(e => {
      if (e.closest('.js-theme-utility-rte-table-wrap')) return;
      const t = document.createElement('div');
      var o, n;
      t.classList.add('js-theme-utility-rte-table-wrap'),
        t.setAttribute('style', 'overflow:auto;-webkit-overflow-scrolling:touch'),
        (n = t),
        (o = e).parentNode.insertBefore(n, o),
        n.appendChild(o);
    });
  }),
  window.theme.wrapRteTables();
const scrollEndSupported = 'undefined' == typeof window || 'onscrollend' in window;
scrollEndSupported || import('scrollyfills');
//# sourceMappingURL=global.js.map

// 异步函数，用于将文本复制到剪贴板
async function copyToClipboard(textToCopy, toastText) {
  try {
    await navigator.clipboard.writeText(textToCopy);
    toast(toastText)
  } catch (err) {
    fallbackCopy(textToCopy, toastText)
  }
}

function fallbackCopy(textToCopy, toastText) {
  const textarea = document.createElement('textarea');
  textarea.value = textToCopy;
  textarea.style.position = 'fixed';
  textarea.style.opacity = 0;
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand('copy');
    toast(toastText)
  } catch (err) {
    console.error('faild to copy text:', err);
  }
}

function toast(text) {
  const toast = document.createElement('div');
  toast.classList.add('toast');
  toast.innerText = text;
  document.body.appendChild(toast);
  setTimeout(() => {
    toast.remove();
  }, 2000);
}

function setRem() {
  let _fontSizeRatio = 1
  if (window.innerWidth < 769) {
    _fontSizeRatio = (window.innerWidth / 800);
  }
  document.documentElement.style.setProperty('--fontSizeRatio', _fontSizeRatio);
}
window.addEventListener('resize', () => {
  setRem();
});
setRem();